import { Outlet } from 'react-router-dom';

export default function PriorProject() {
  return (
      <Outlet/>
  )
}
